import './host'

import { MailingService } from '@graft/nuget-gc.webportals.mailing'

import { getSessionToken } from '@common/core/helpers'
import { isVisionLocal } from '@common/core/utils/isVisionLocal'

import { FeedbackPayload } from './types'

export async function sendFeedbackEmail(payload: FeedbackPayload): Promise<void> {
  try {
    if (isVisionLocal()) {
      return
    }

    const token = await getSessionToken()
    const { topic, message, rating } = payload

    await MailingService.sendFeedbackEmail(token, topic, message, rating)
  } catch (error) {
    console.error('Failed to send feedback email:', error)
  }
}
